import React, { useEffect } from 'react';
import TabPageContainer from '~components/atoms/TabPageContainer';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';
import ProjectApprovalTable from './ReleaseEarmarkApprovalTable';
import ProjectApprovalTablePaginator from './ReleaseEarmarkApprovalPagination';
import ReleaseEarmarkApprovalSearchAndFilterBar from './ReleaseEarmarkApprovalSearchAndFilterBar';
import ConfirmUpdateReleaseEarmarkStatusModal from './ConfirmUpdateReleaseEarmarkStatusModal';

const ReleaseEarmarkApproval = () => {
    const dispatch = useAppDispatch();

    const releaseEarmarkListingIndex = useAppSelector(state => state.approval.pendingReleaseEarmarkListing.index);

    useEffect(() => {
        dispatch(combinedActions.approvalGetPendingReleaseEarmarkListingAttempt());
    }, [releaseEarmarkListingIndex]);

    return (
        <TabPageContainer>
            <ReleaseEarmarkApprovalSearchAndFilterBar />

            <ProjectApprovalTable />

            <ProjectApprovalTablePaginator />

            <ConfirmUpdateReleaseEarmarkStatusModal />
        </TabPageContainer>
    );
};

export default ReleaseEarmarkApproval;
